import { gql } from '@apollo/client'
import { MAESTRO_EMPLOYER_FRAGMENT } from '../apollo.fragment'

export const SIGNIN_SYMPLR_SSO_MUTATION = gql`
	mutation signInSymplrSso($payload: String!) {
		signInSymplrSso(payload: $payload) {
			authToken {
				accessToken
				expiresIn
				refreshToken
				tokenType
			}
			notificationChannel
			employer {
				...maestroEmployerFragment
			}
			entity {
				modelName
				fieldValue
				fieldName
			}
		}
	}
	${MAESTRO_EMPLOYER_FRAGMENT}
`

export const SIGNIN_SALESFORCE_SSO_MUTATION = gql`
	mutation signInSalesforceSso($payload: String!) {
		signInSalesforceSso(payload: $payload) {
			authToken {
				accessToken
				expiresIn
				refreshToken
				tokenType
			}
			notificationChannel
			employer {
				...maestroEmployerFragment
			}
			entity {
				modelName
				fieldValue
				fieldName
			}
		}
	}
	${MAESTRO_EMPLOYER_FRAGMENT}
`
